import { TrainingStep } from "../../components/common/TrainingGuide";

const whatsappSteps: TrainingStep[] = [
  {
    title: "WhatsApp Customer Service Overview",
    description:
      "This dashboard shows all active WhatsApp conversations handled by the AI agent. Customers reach us via UltraMsg; the bot responds in Arabic or English based on their language.",
    tip: "The AI handles routine enquiries automatically — you only need to intervene when the live agent mode is triggered.",
  },
  {
    title: "Viewing Active Conversations",
    description:
      "The conversation list shows each customer's phone number, how many messages they've sent, the current menu they're in, and the last message received. Rows highlighted in amber indicate a pending lead was created.",
    tip: "Click any row to see the full conversation history and context.",
  },
  {
    title: "Live Agent Mode",
    description:
      "When a customer requests a human agent, the conversation is flagged with a 'Live Agent' badge. At that point the AI stops responding — you must reply manually via WhatsApp or through the broadcast feature.",
    tip: "Resolve live agent sessions promptly. Customers left waiting for more than 15 minutes often drop off.",
  },
  {
    title: "Creating Leads from Conversations",
    description:
      "The AI automatically creates a CRM lead when a customer expresses purchase intent. You'll see 'Lead Created ✓' on the conversation row. Go to CRM to find the lead pre-filled with their details.",
    tip: "Check the CRM pipeline every morning — overnight conversations often generate fresh leads.",
  },
  {
    title: "Broadcast Messages",
    description:
      "Use the Broadcast feature to send a single WhatsApp message to multiple customers at once. Select leads from the CRM, compose your message, and fire. Delivery status is shown per recipient.",
    tip: "Keep broadcasts short and personal. Long promotional texts get marked as spam.",
  },
  {
    title: "Voice Messages (PTT)",
    description:
      "When a customer sends a voice note, the system transcribes it using Groq STT (or OpenAI as fallback), processes the intent, and replies with a synthesised voice message via ElevenLabs.",
    tip: "Voice mode requires GROQ_API_KEY or OPENAI_API_KEY to be set in .env. If voice is silent, check APP_PUBLIC_URL is correct.",
  },
];

export default whatsappSteps;
